import InputMask from 'primevue/inputmask'

type Caret = { begin: number; end: number }
type InputMaskContext = { $el: HTMLInputElement | undefined }
type CaretMethod = (this: InputMaskContext, first?: number, last?: number) => Caret | undefined

export const patchInputMaskCaret = () => {
  const methods = (InputMask as unknown as { methods: { caret: CaretMethod } }).methods
  const originalCaret = methods.caret

  methods.caret = function (this: InputMaskContext, first?: number, last?: number) {
    const result = originalCaret.call(this, first, last)
    if (typeof first === 'number' || result) return result

    const length = this.$el?.value?.length ?? 0
    return {
      begin: this.$el?.selectionStart ?? length,
      end: this.$el?.selectionEnd ?? length
    }
  }
}
